// extracted by mini-css-extract-plugin
export default {"wrapper":"About_wrapper__ErBtQ","mobileMenu":"About_mobileMenu__yGBp2","mobileItem":"About_mobileItem__PvyLk"};